<template>
  <div/>
</template>
<script>
export default {
  name: 'emptyTriggerParams',
  created() {
    this.$emit('update:value', null)
  },
  props: {
    value: {
      type: String,
    },
    disabled: {
      type: Boolean
    }
  },
}
</script>
